import {faExclamationCircle, faBan, faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React, {useEffect, useState} from "react";
import {ReportButtonInfo} from "../types";

export const buttons: ReportButtonInfo[] = [{
    category: 'dangerous',
    id: 'report-category-dangerous-button',
    icon: faExclamationCircle,
    iconColor: '#D32F2F',
    bodyText: 'Report as dangerous to my security team'
}, {
    category: 'spam',
    id: 'report-category-spam-button',
    icon: faBan,
    iconColor: '#333333',
    bodyText: 'Report as spam to my security team'
}, {
    category: 'safe',
    id: 'report-category-safe-button',
    icon: faCheckCircle,
    iconColor: '#388E3C',
    bodyText: 'Mark as safe and hide warnings'
},]

type ReportButtonsProps = {
    onSelected: (category: string) => void
    disabled?: boolean
}

const ReportButtons = ({onSelected}: ReportButtonsProps) => {
    const [selected, setSelected] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (selected) {
            onSelected(selected)
        }
    }, [selected,onSelected])

    const onPressEnter = (event: React.KeyboardEvent<HTMLDivElement>, category: string) => {
        if (event.key === 'Enter') {
            setSelected(category)
        }
    }

    return (<div className="reports-buttons row">
        {buttons.map(button => (<div key={button.id} tabIndex={0} onKeyPress={(e) => onPressEnter(e, button.category)}
                                     onClick={() => setSelected(button.category)} aria-controls="button"
                                     className={selected === button.category ? "button selected" : "button"}>
            <FontAwesomeIcon size={"2x"} className="rule-icon" color={button.iconColor}
                             icon={button.icon}/><span
            className="rule">{button.bodyText}</span>
        </div>))}
    </div>)
}
export default ReportButtons;
